import React from "react";

export default () => (
  <p>This is the about page</p>
)